import React, { useState, useEffect, useRef } from "react";
import * as FormValidation from "../util/FormValidation";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Payment from "./common/Payment";
import Reload from "./common/Reload";
import ReactFlagsSelect from "react-flags-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ShopIcon from "../icon/ShopIcon";
import { routeToPage } from "../util/RouteToPage";
import PagePath from "../util/RoutePagePath";
import "../style/checkout.scss";
import Number from "./common/Number";
import { currency } from "./common/Common";

const Checkout = () => {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [country, setCountry] = useState("US");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [zip, setZip] = useState("");
  const [phone, setPhone] = useState("");
  const [tip, setTip] = useState("");
  const [isEmail, setIsEmail] = useState(false);
  const [isFirstName, setIsFirstName] = useState(false);
  const [isLastName, setIsLastName] = useState(false);
  const [isCountry, setIsCountry] = useState(false);
  const [isAddress, setIsAddress] = useState(false);
  const [isCity, setIsCity] = useState(false);
  const [isZip, setIsZip] = useState(false);
  const [isPhone, setIsPhone] = useState(false);
  const [next, setNext] = useState(false);
  const [reloadingShow, setReloadingShow] = useState(false);

  const paymentRef = useRef();

  const cartItems = useSelector((state) => state.cart.cartItems);
  const cartTotal = cartItems.reduce(
    (sum, item) => sum + item.total * item.quantity,
    0,
  );

  console.log(cartItems);
  console.log(cartTotal);

  const navigate = useNavigate();

  const inputChange = (e, type) => {
    let telephone;
    switch (type) {
      case "email":
        setEmail(e.target.value);
        setTip("");
        break;
      case "firstName":
        setFirstName(e.target.value);
        setTip("");
        break;
      case "lastName":
        setLastName(e.target.value);
        setTip("");
        break;
      case "country":
        setCountry(e.target.value);
        setTip("");
        break;
      case "address":
        setAddress(e.target.value);
        setTip("");
        break;
      case "city":
        setCity(e.target.value);
        setTip("");
        break;
      case "zip":
        setZip(e.target.value);
        setTip("");
        break;
      case "phone":
        telephone = e.replace(/[-\s()]/g, "");
        setPhone(telephone);
        setTip("");
        break;

      default:
        break;
    }
  };

  const blurInput = (e, type) => {
    let reg;
    switch (type) {
      case "email":
        if (!FormValidation.isValidEmail(e.target.value)) {
          setIsEmail(true);
        } else {
          setIsEmail(false);
        }
        break;
      case "firstName":
        if (e.target.value.trim() === "") {
          setIsFirstName(true);
        } else {
          setIsFirstName(false);
        }
        break;
      case "lastName":
        if (e.target.value.trim() === "") {
          setIsLastName(true);
        } else {
          setIsLastName(false);
        }
        break;
      case "country":
        if (e.target.value.trim() === "") {
          setIsCountry(true);
        } else {
          setIsCountry(false);
        }
        break;
      case "city":
        if (e.target.value.trim() === "") {
          setIsCity(true);
        } else {
          setIsCity(false);
        }
        break;
      case "address":
        if (e.target.value.trim() === "") {
          setIsAddress(true);
        } else {
          setIsAddress(false);
        }
        break;
      case "zip":
        reg = /^[a-zA-Z0-9-_]{4,30}$/;
        if (!reg.test(e.target.value)) {
          setIsZip(true);
        } else {
          setIsZip(false);
        }
        break;
      case "phone":
        if (FormValidation.isValidPhoneNumber(e)) {
          setIsPhone(false);
        } else {
          setIsPhone(true);
        }
        break;
      default:
        break;
    }
  };

  const setSelected = (code) => {
    setCountry(code);
  };

  const clikctoPay = () => {
    let paymentVaild = paymentRef.current.getValid();
    let { cardNumber, cvc, expiry } = paymentVaild;
    let fields = [
      email,
      firstName,
      lastName,
      address,
      zip,
      city,
      cardNumber,
      cvc,
      expiry,
    ];

    let next = fields.some((field) => (field || "").trim() !== "");

    if (!next) {
      return;
    }
    if (isEmail) return setTip("please enter your email");
    if (isPhone) return setTip("please enter your phone number");
    setReloadingShow(true);
    let flag = setTimeout(() => {
      clearTimeout(flag);
      routeToPage(navigate, PagePath.SUCCESS_PAGE);
    }, 3000);
  };

  return (
    <React.Fragment>
      <Reload reloadingShow={reloadingShow} />
      <div className="min-h-screen">
        {/* top bar */}
        <div className="border-b border-black/5 backdrop-blur-md">
          <div className="mx-auto flex h-[90px] max-w-[1200px] items-center justify-between px-10">
            <div>
              <h1
                onClick={() => routeToPage(navigate, PagePath.HOME_PAGE)}
                className="cursor-pointer text-[30px] font-light tracking-[8px] transition hover:opacity-60"
              >
                Elvorloy
              </h1>
            </div>

            <div className="hidden items-center gap-10 text-[12px] uppercase tracking-[3px] text-black/50 lg:flex"></div>

            <div
              onClick={() => routeToPage(navigate, PagePath.CART_PAGE)}
              className=""
            >
              <ShopIcon
                size={20}
                color="#111"
                className="transition duration-300 group-hover:scale-110"
              />
            </div>
          </div>
        </div>

        {/* content */}
        <div className="mx-auto grid max-w-[1200px] grid-cols-[1fr_460px] gap-14 px-10 py-16">
          {/* LEFT */}
          <div className="rounded-[14px] p-10">
            <div className="mb-5">
              <h2 className="text-[20px] tracking-[5px]">Billing Details</h2>
            </div>

            <div className="space-y-2">
              {/* email */}
              <div>
                <p className="mb-3 text-[11px] uppercase tracking-[3px] text-black/40">
                  Email Address
                </p>

                <input
                  type="text"
                  placeholder="Enter your email"
                  onChange={(e) => inputChange(e, "email")}
                  onBlur={(e) => blurInput(e, "email")}
                  className="h-[48px] w-full border border-black/10 bg-[#fafafa] px-5 text-[15px] outline-none transition duration-300 focus:border-black focus:bg-white"
                />
              </div>

              {/* country */}
              <div>
                <p className="mb-3 text-[11px] uppercase tracking-[3px] text-black/40">
                  Country
                </p>

                <ReactFlagsSelect
                  selected={country}
                  onSelect={(code) => setSelected(code)}
                />
              </div>

              {/* names */}
              <div className="grid grid-cols-2 gap-5">
                <div>
                  <p className="mb-3 text-[11px] uppercase tracking-[3px] text-black/40">
                    First Name
                  </p>

                  <input
                    type="text"
                    placeholder="First name"
                    onChange={(e) => inputChange(e, "firstName")}
                    onBlur={(e) => blurInput(e, "firstName")}
                    className="h-[48px] w-full border border-black/10 bg-[#fafafa] px-5 outline-none transition duration-300 focus:border-black focus:bg-white"
                  />
                </div>

                <div>
                  <p className="mb-3 text-[11px] uppercase tracking-[3px] text-black/40">
                    Last Name
                  </p>

                  <input
                    type="text"
                    placeholder="Last name"
                    onChange={(e) => inputChange(e, "lastName")}
                    onBlur={(e) => blurInput(e, "lastName")}
                    className="h-[48px] w-full border border-black/10 bg-[#fafafa] px-5 outline-none transition duration-300 focus:border-black focus:bg-white"
                  />
                </div>
              </div>

              {/* address */}
              <div>
                <p className="mb-3 text-[11px] uppercase tracking-[3px] text-black/40">
                  Address
                </p>

                <input
                  type="text"
                  placeholder="Street address"
                  onChange={(e) => inputChange(e, "address")}
                  onBlur={(e) => blurInput(e, "address")}
                  className="h-[48px] w-full border border-black/10 bg-[#fafafa] px-5 outline-none transition duration-300 focus:border-black focus:bg-white"
                />
              </div>

              {/* city / zip */}
              <div className="grid grid-cols-2 gap-5">
                <div>
                  <p className="mb-3 text-[11px] uppercase tracking-[3px] text-black/40">
                    City
                  </p>

                  <input
                    type="text"
                    placeholder="City"
                    onChange={(e) => inputChange(e, "city")}
                    onBlur={(e) => blurInput(e, "city")}
                    className="h-[48px] w-full border border-black/10 bg-[#fafafa] px-5 outline-none transition duration-300 focus:border-black focus:bg-white"
                  />
                </div>

                <div>
                  <p className="mb-3 text-[11px] uppercase tracking-[3px] text-black/40">
                    Zip Code
                  </p>

                  <input
                    type="text"
                    placeholder="Zip code"
                    onChange={(e) => inputChange(e, "zip")}
                    onBlur={(e) => blurInput(e, "zip")}
                    className="h-[48px] w-full border border-black/10 bg-[#fafafa] px-5 outline-none transition duration-300 focus:border-black focus:bg-white"
                  />
                </div>
              </div>

              {/* phone */}
              <div>
                <p className="mb-3 text-[11px] uppercase tracking-[3px] text-black/40">
                  Phone Number
                </p>

                <div className="border border-black/10 bg-[#fafafa] p-2">
                  <PhoneInput
                    country={"us"}
                    value={phone}
                    onChange={(value) => inputChange(value, "phone")}
                    onBlur={() => blurInput(phone, "phone")}
                    className="w-full"
                  />
                </div>
              </div>

              {/* payment */}
              <div className="pt-2">
                <p className="mb-5 text-[11px] uppercase tracking-[3px] text-black/40">
                  Payment Method
                </p>

                <div className="rounded-[4px] border border-black/10 bg-[#fafafa] px-5 py-2">
                  <Payment ref={paymentRef} />
                </div>
              </div>

              {/* tip */}
              {tip && (
                <div className="rounded-xl border border-red-200 bg-red-50 px-5 py-4 text-sm text-red-500">
                  {tip}
                </div>
              )}

              {/* button */}
              <button
                onClick={clikctoPay}
                disabled={next}
                className="mt-8 flex h-[64px] w-full items-center justify-center bg-black text-[12px] uppercase tracking-[5px] text-white transition duration-300 hover:opacity-85 disabled:cursor-not-allowed disabled:opacity-40"
              >
                Complete Payment
              </button>
            </div>
          </div>

          {/* RIGHT */}
          <div>
            <div className="rounded-[4px]p-10 sticky top-10">
              <div className="mb-10">
                <p className="mb-3 text-[12px] uppercase tracking-[5px]">
                  Order Summary
                </p>
              </div>

              {/* items */}
              <div className="space-y-8">
                {cartItems.map((item) => (
                  <div
                    key={item.id}
                    className="flex items-start justify-between gap-5 border-b border-white/10 pb-2"
                  >
                    <div className="flex gap-4">
                      {/* image */}
                      <div className="relative h-[80px] w-[80px] overflow-hidden rounded-[5px] bg-white/5">
                        <img
                          src={item?.image?.[0]}
                          alt={item.title}
                          className="h-full w-full object-cover"
                        />

                        <div className="absolute right-2 top-2 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-white px-1 text-[10px] font-medium text-black">
                          {item.quantity}
                        </div>
                      </div>

                      {/* title */}
                      <div>
                        <h4 className="mb-2 text-[15px] leading-[24px]">
                          {item.title}
                        </h4>

                        <p className="text-[12px] text-white">
                          Premium Collection
                        </p>
                      </div>
                    </div>

                    {/* total */}
                    <div className="text-[15px]">
                      {currency}
                      {item?.total?.toFixed(2)}
                    </div>
                  </div>
                ))}
              </div>

              {/* totals */}
              <div className="mt-5 space-y-3 border-t border-white/10 pt-8">
                <div className="flex items-center justify-between">
                  <span className="text-[13px] uppercase tracking-[2px]">
                    Shipping
                  </span>

                  <span>Free</span>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-[13px] uppercase tracking-[2px]">
                    Taxes
                  </span>

                  <span>Included</span>
                </div>

                <div className="flex items-center justify-between pt-4">
                  <span className="text-[15px] uppercase tracking-[3px]">
                    Total
                  </span>

                  <span className="text-[24px] font-extralight">
                    <span className="mr-2 text-[16px]">{currency}</span>
                    {cartTotal.toFixed(2)}
                  </span>
                </div>
              </div>

              {/* policy */}
              <div className="mt-5 border-t border-white/50 pt-6 text-[13px] leading-[26px]">
                By completing your purchase, you agree to our{" "}
                <span
                  onClick={() => routeToPage(navigate, PagePath.SHIPPING_PAGE)}
                >
                  shipping
                </span>{" "}
                <span className="px-1">and</span>
                <span
                  onClick={() => routeToPage(navigate, PagePath.RETURN_PAGE)}
                >
                  return
                </span>{" "}
                policies.
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Checkout;
